module.exports = __webpack_public_path__ + "img/quality-check.c1a4c7ba.jpg";